import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurveyQuestion } from '../types';

import { useSxStyles } from './useStyles';

type Props = {
  question: SurveyQuestion;
  control: Control;
};

export const SingleChoice: React.FC<Props> = ({ control, question }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  return (
    <Grid
      container
      item
      xs={12}
      direction="row"
      key={question.id}
      justifyContent="space-between"
    >
      <FormControl sx={sxStyles.formControl} fullWidth required>
        <Grid item sx={{ ...sxStyles.question, ...sxStyles.stretch }}>
          <FormLabel sx={sxStyles.formControlLabel}>{question.text}</FormLabel>
        </Grid>
        <Grid item sx={sxStyles.stretch}>
          <Controller
            control={control}
            name={`${question.id}`}
            rules={{
              required: `${t('laThisRequired')}`,
            }}
            defaultValue=""
            render={({ field }) => (
              <RadioGroup
                {...field}
                aria-label={`${question.type} question`}
                name={`${question.id}`}
                sx={sxStyles.group}
              >
                {question.options
                  ? question.options.map((choice) => (
                      <FormControlLabel
                        key={choice.index}
                        value={choice.id ? choice.id.toString() : ''}
                        control={<Radio color="primary" sx={sxStyles.radio} />}
                        label={choice.text as string}
                      />
                    ))
                  : {}}
              </RadioGroup>
            )}
          />
        </Grid>
      </FormControl>
    </Grid>
  );
};
